import { Link } from 'react-router-dom';
import { useAppContext } from '../context/appContext';
import { FaShoppingCart } from 'react-icons/fa'

const ShoppingCart = () => {

  const {
    shoppingCart,
  } = useAppContext();
  return (
    <div style={{ textAlign: 'right', marginBottom: 20 }}>
      <Link to={'/e-commerce/checkout'}>
        <FaShoppingCart />({shoppingCart.length})
      </Link>
    </div>
  )
}

export default ShoppingCart